// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__3N4r4","header":"ClearentDisclaimer_header__24wfb","inner":"ClearentDisclaimer_inner__2Ff0a"};